/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateProductDto,
  CreateProductWithSelectionsDto,
  ProductDetailDto,
  ProductListItemDto,
  ProductsControllerGetProductBillOfOperations200,
  ProductsControllerGetProductBillOfOperationsParams,
  ProductsControllerListProductsParams,
  UpdateProductDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns all products for the specified partner with container selections, Product Code, complexity score, and linked Bill of Operations.
 * @summary List products for a partner
 */
export type productsControllerListProductsResponse200 = {
  data: ProductListItemDto[]
  status: 200
}

export type productsControllerListProductsResponse401 = {
  data: void
  status: 401
}
    
export type productsControllerListProductsResponseSuccess = (productsControllerListProductsResponse200) & {
  headers: Headers;
};
export type productsControllerListProductsResponseError = (productsControllerListProductsResponse401) & {
  headers: Headers;
};

export type productsControllerListProductsResponse = (productsControllerListProductsResponseSuccess | productsControllerListProductsResponseError)

export const getProductsControllerListProductsUrl = (params: ProductsControllerListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/products?${stringifiedParams}` : `/products`
}

export const productsControllerListProducts = async (params: ProductsControllerListProductsParams, options?: RequestInit): Promise<productsControllerListProductsResponse> => {
  
  return customFetch<productsControllerListProductsResponse>(getProductsControllerListProductsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProductsControllerListProductsQueryKey = (params?: ProductsControllerListProductsParams,) => {
    return [
    `/products`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProductsControllerListProductsQueryOptions = <TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(params: ProductsControllerListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsControllerListProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsControllerListProducts>>> = ({ signal }) => productsControllerListProducts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductsControllerListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof productsControllerListProducts>>>
export type ProductsControllerListProductsQueryError = void


export function useProductsControllerListProducts<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsControllerListProducts>>,
          TError,
          Awaited<ReturnType<typeof productsControllerListProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerListProducts<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsControllerListProducts>>,
          TError,
          Awaited<ReturnType<typeof productsControllerListProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerListProducts<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List products for a partner
 */

export function useProductsControllerListProducts<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductsControllerListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List products for a partner
 */
export const prefetchProductsControllerListProductsQuery = async <TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 queryClient: QueryClient, params: ProductsControllerListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductsControllerListProductsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProductsControllerListProductsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(params: ProductsControllerListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsControllerListProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsControllerListProducts>>> = ({ signal }) => productsControllerListProducts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductsControllerListProductsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productsControllerListProducts>>>
export type ProductsControllerListProductsSuspenseQueryError = void


export function useProductsControllerListProductsSuspense<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerListProductsSuspense<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerListProductsSuspense<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List products for a partner
 */

export function useProductsControllerListProductsSuspense<TData = Awaited<ReturnType<typeof productsControllerListProducts>>, TError = void>(
 params: ProductsControllerListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerListProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductsControllerListProductsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a product by selecting one option per container. Auto-generates the Product Code from selected option codes and creates a linked Bill of Operations. Returns 409 if the Product Code already exists for this partner.
 * @summary Create a product with container selections
 */
export type productsControllerCreateProductWithSelectionsResponse201 = {
  data: ProductDetailDto
  status: 201
}

export type productsControllerCreateProductWithSelectionsResponse401 = {
  data: void
  status: 401
}

export type productsControllerCreateProductWithSelectionsResponse409 = {
  data: void
  status: 409
}
    
export type productsControllerCreateProductWithSelectionsResponseSuccess = (productsControllerCreateProductWithSelectionsResponse201) & {
  headers: Headers;
};
export type productsControllerCreateProductWithSelectionsResponseError = (productsControllerCreateProductWithSelectionsResponse401 | productsControllerCreateProductWithSelectionsResponse409) & {
  headers: Headers;
};

export type productsControllerCreateProductWithSelectionsResponse = (productsControllerCreateProductWithSelectionsResponseSuccess | productsControllerCreateProductWithSelectionsResponseError)

export const getProductsControllerCreateProductWithSelectionsUrl = () => {


  

  return `/products`
}

export const productsControllerCreateProductWithSelections = async (createProductWithSelectionsDto: CreateProductWithSelectionsDto, options?: RequestInit): Promise<productsControllerCreateProductWithSelectionsResponse> => {
  
  return customFetch<productsControllerCreateProductWithSelectionsResponse>(getProductsControllerCreateProductWithSelectionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProductWithSelectionsDto,)
  }
);}




export const getProductsControllerCreateProductWithSelectionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsControllerCreateProductWithSelections>>, TError,{data: CreateProductWithSelectionsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof productsControllerCreateProductWithSelections>>, TError,{data: CreateProductWithSelectionsDto}, TContext> => {

const mutationKey = ['productsControllerCreateProductWithSelections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsControllerCreateProductWithSelections>>, {data: CreateProductWithSelectionsDto}> = (props) => {
          const {data} = props ?? {};

          return  productsControllerCreateProductWithSelections(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsControllerCreateProductWithSelectionsMutationResult = NonNullable<Awaited<ReturnType<typeof productsControllerCreateProductWithSelections>>>
    export type ProductsControllerCreateProductWithSelectionsMutationBody = CreateProductWithSelectionsDto
    export type ProductsControllerCreateProductWithSelectionsMutationError = void

    /**
 * @summary Create a product with container selections
 */
export const useProductsControllerCreateProductWithSelections = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsControllerCreateProductWithSelections>>, TError,{data: CreateProductWithSelectionsDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsControllerCreateProductWithSelections>>,
        TError,
        {data: CreateProductWithSelectionsDto},
        TContext
      > => {

      const mutationOptions = getProductsControllerCreateProductWithSelectionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns a single product with all container selections, complexity score, and linked Bill of Operations.
 * @summary Get product detail
 */
export type productsControllerGetProductResponse200 = {
  data: ProductDetailDto
  status: 200
}

export type productsControllerGetProductResponse401 = {
  data: void
  status: 401
}

export type productsControllerGetProductResponse404 = {
  data: void
  status: 404
}
    
export type productsControllerGetProductResponseSuccess = (productsControllerGetProductResponse200) & {
  headers: Headers;
};
export type productsControllerGetProductResponseError = (productsControllerGetProductResponse401 | productsControllerGetProductResponse404) & {
  headers: Headers;
};

export type productsControllerGetProductResponse = (productsControllerGetProductResponseSuccess | productsControllerGetProductResponseError)

export const getProductsControllerGetProductUrl = (productId: string,) => {


  

  return `/products/${productId}`
}

export const productsControllerGetProduct = async (productId: string, options?: RequestInit): Promise<productsControllerGetProductResponse> => {
  
  return customFetch<productsControllerGetProductResponse>(getProductsControllerGetProductUrl(productId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProductsControllerGetProductQueryKey = (productId?: string,) => {
    return [
    `/products/${productId}`
    ] as const;
    }

    
export const getProductsControllerGetProductQueryOptions = <TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsControllerGetProductQueryKey(productId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsControllerGetProduct>>> = ({ signal }) => productsControllerGetProduct(productId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(productId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductsControllerGetProductQueryResult = NonNullable<Awaited<ReturnType<typeof productsControllerGetProduct>>>
export type ProductsControllerGetProductQueryError = void


export function useProductsControllerGetProduct<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsControllerGetProduct>>,
          TError,
          Awaited<ReturnType<typeof productsControllerGetProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProduct<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsControllerGetProduct>>,
          TError,
          Awaited<ReturnType<typeof productsControllerGetProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProduct<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get product detail
 */

export function useProductsControllerGetProduct<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductsControllerGetProductQueryOptions(productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get product detail
 */
export const prefetchProductsControllerGetProductQuery = async <TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 queryClient: QueryClient, productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductsControllerGetProductQueryOptions(productId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProductsControllerGetProductSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(productId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsControllerGetProductQueryKey(productId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsControllerGetProduct>>> = ({ signal }) => productsControllerGetProduct(productId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductsControllerGetProductSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productsControllerGetProduct>>>
export type ProductsControllerGetProductSuspenseQueryError = void


export function useProductsControllerGetProductSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProductSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProductSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get product detail
 */

export function useProductsControllerGetProductSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProduct>>, TError = void>(
 productId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductsControllerGetProductSuspenseQueryOptions(productId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type productsControllerUpdateProductResponse201 = {
  data: void
  status: 201
}
    
export type productsControllerUpdateProductResponseSuccess = (productsControllerUpdateProductResponse201) & {
  headers: Headers;
};
;

export type productsControllerUpdateProductResponse = (productsControllerUpdateProductResponseSuccess)

export const getProductsControllerUpdateProductUrl = (productId: string,) => {


  

  return `/products/${productId}`
}

export const productsControllerUpdateProduct = async (productId: string,
    updateProductDto: UpdateProductDto, options?: RequestInit): Promise<productsControllerUpdateProductResponse> => {
  
  return customFetch<productsControllerUpdateProductResponse>(getProductsControllerUpdateProductUrl(productId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProductDto,)
  }
);}




export const getProductsControllerUpdateProductMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsControllerUpdateProduct>>, TError,{productId: string;data: UpdateProductDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof productsControllerUpdateProduct>>, TError,{productId: string;data: UpdateProductDto}, TContext> => {

const mutationKey = ['productsControllerUpdateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsControllerUpdateProduct>>, {productId: string;data: UpdateProductDto}> = (props) => {
          const {productId,data} = props ?? {};

          return  productsControllerUpdateProduct(productId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsControllerUpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof productsControllerUpdateProduct>>>
    export type ProductsControllerUpdateProductMutationBody = UpdateProductDto
    export type ProductsControllerUpdateProductMutationError = unknown

    export const useProductsControllerUpdateProduct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsControllerUpdateProduct>>, TError,{productId: string;data: UpdateProductDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsControllerUpdateProduct>>,
        TError,
        {productId: string;data: UpdateProductDto},
        TContext
      > => {

      const mutationOptions = getProductsControllerUpdateProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns a product's Bill of Operations and the operations that belong to it, ordered by operation_order, plus the list of available versions and per-status work-order counts for the shown version. Defaults to the current version, whose rows carry the operation default work_time / headcount plus the effective values once product overrides are applied. When the `version` query param names an older version, that version is returned as-released (base values from the immutable snapshot, no current overrides applied). May return `null` when the product has no Bill of Operations row (legacy products created before BoO automation).
 * @summary Get a product's Bill of Operations
 */
export type productsControllerGetProductBillOfOperationsResponse200 = {
  data: ProductsControllerGetProductBillOfOperations200
  status: 200
}

export type productsControllerGetProductBillOfOperationsResponse401 = {
  data: void
  status: 401
}

export type productsControllerGetProductBillOfOperationsResponse404 = {
  data: void
  status: 404
}
    
export type productsControllerGetProductBillOfOperationsResponseSuccess = (productsControllerGetProductBillOfOperationsResponse200) & {
  headers: Headers;
};
export type productsControllerGetProductBillOfOperationsResponseError = (productsControllerGetProductBillOfOperationsResponse401 | productsControllerGetProductBillOfOperationsResponse404) & {
  headers: Headers;
};

export type productsControllerGetProductBillOfOperationsResponse = (productsControllerGetProductBillOfOperationsResponseSuccess | productsControllerGetProductBillOfOperationsResponseError)

export const getProductsControllerGetProductBillOfOperationsUrl = (productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/products/${productId}/bill-of-operations?${stringifiedParams}` : `/products/${productId}/bill-of-operations`
}

export const productsControllerGetProductBillOfOperations = async (productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: RequestInit): Promise<productsControllerGetProductBillOfOperationsResponse> => {
  
  return customFetch<productsControllerGetProductBillOfOperationsResponse>(getProductsControllerGetProductBillOfOperationsUrl(productId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProductsControllerGetProductBillOfOperationsQueryKey = (productId?: string,
    params?: ProductsControllerGetProductBillOfOperationsParams,) => {
    return [
    `/products/${productId}/bill-of-operations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProductsControllerGetProductBillOfOperationsQueryOptions = <TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsControllerGetProductBillOfOperationsQueryKey(productId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>> = ({ signal }) => productsControllerGetProductBillOfOperations(productId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(productId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductsControllerGetProductBillOfOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>>
export type ProductsControllerGetProductBillOfOperationsQueryError = void


export function useProductsControllerGetProductBillOfOperations<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params: undefined |  ProductsControllerGetProductBillOfOperationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>,
          TError,
          Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProductBillOfOperations<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>,
          TError,
          Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProductBillOfOperations<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a product's Bill of Operations
 */

export function useProductsControllerGetProductBillOfOperations<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductsControllerGetProductBillOfOperationsQueryOptions(productId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a product's Bill of Operations
 */
export const prefetchProductsControllerGetProductBillOfOperationsQuery = async <TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 queryClient: QueryClient, productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductsControllerGetProductBillOfOperationsQueryOptions(productId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProductsControllerGetProductBillOfOperationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsControllerGetProductBillOfOperationsQueryKey(productId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>> = ({ signal }) => productsControllerGetProductBillOfOperations(productId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductsControllerGetProductBillOfOperationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>>
export type ProductsControllerGetProductBillOfOperationsSuspenseQueryError = void


export function useProductsControllerGetProductBillOfOperationsSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params: undefined |  ProductsControllerGetProductBillOfOperationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProductBillOfOperationsSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductsControllerGetProductBillOfOperationsSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a product's Bill of Operations
 */

export function useProductsControllerGetProductBillOfOperationsSuspense<TData = Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError = void>(
 productId: string,
    params?: ProductsControllerGetProductBillOfOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productsControllerGetProductBillOfOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductsControllerGetProductBillOfOperationsSuspenseQueryOptions(productId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type productsControllerCreateProductResponse201 = {
  data: void
  status: 201
}
    
export type productsControllerCreateProductResponseSuccess = (productsControllerCreateProductResponse201) & {
  headers: Headers;
};
;

export type productsControllerCreateProductResponse = (productsControllerCreateProductResponseSuccess)

export const getProductsControllerCreateProductUrl = () => {


  

  return `/products/create`
}

export const productsControllerCreateProduct = async (createProductDto: CreateProductDto, options?: RequestInit): Promise<productsControllerCreateProductResponse> => {
  
  return customFetch<productsControllerCreateProductResponse>(getProductsControllerCreateProductUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProductDto,)
  }
);}




export const getProductsControllerCreateProductMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsControllerCreateProduct>>, TError,{data: CreateProductDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof productsControllerCreateProduct>>, TError,{data: CreateProductDto}, TContext> => {

const mutationKey = ['productsControllerCreateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsControllerCreateProduct>>, {data: CreateProductDto}> = (props) => {
          const {data} = props ?? {};

          return  productsControllerCreateProduct(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsControllerCreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof productsControllerCreateProduct>>>
    export type ProductsControllerCreateProductMutationBody = CreateProductDto
    export type ProductsControllerCreateProductMutationError = unknown

    export const useProductsControllerCreateProduct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsControllerCreateProduct>>, TError,{data: CreateProductDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsControllerCreateProduct>>,
        TError,
        {data: CreateProductDto},
        TContext
      > => {

      const mutationOptions = getProductsControllerCreateProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    